
import { Course } from '../types';

export const direct_access: Course = {
  id: "direct_access",
  title: "Direct Access Barristers",
  description: "Save money by hiring a barrister directly, bypassing the solicitor.",
  icon: "🎓",
  totalModules: 12,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/direct_access/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "What is the primary advantage of the Direct Access Scheme mentioned in the course slides?",
        "o": [
            "Faster case resolution",
            "Increased solicitor involvement",
            "Massive cost savings",
            "Guaranteed successful outcome"
        ],
        "a": 2
    },
    {
        "q": "According to the course slides, what are barristers primarily responsible for in the division of legal labor?",
        "o": [
            "Case Management and routine correspondence",
            "Administrative lifting and filing documents",
            "Advocacy and courtroom performance",
            "Compiling the court bundle"
        ],
        "a": 2
    },
    {
        "q": "In a Direct Access arrangement, who performs the administrative tasks typically handled by a solicitor?",
        "o": [
            "The barrister",
            "An appointed solicitor",
            "The client",
            "A legal assistant"
        ],
        "a": 2
    },
    {
        "q": "What pricing model is recommended for securing financial certainty and predictability in the Direct Access Model?",
        "o": [
            "Open-ended hourly rates",
            "Contingency fees",
            "The Fixed Fee Model",
            "Retainer fees"
        ],
        "a": 2
    },
    {
        "q": "Which official portal is recommended for sourcing barristers and checking their experience for Direct Access?",
        "o": [
            "courtservice.gov.uk",
            "barcouncil.org.uk",
            "lawfirmfinder.com",
            "directaccessbarristers.co.uk"
        ],
        "a": 1
    }
]
};
